import { useEffect, useMemo, useState } from "react";

const clamp = (value: number, min: number, max: number) => {
  return Math.min(max, Math.max(min, value));
};

export const getTypewriterTotalDurationMs = (text: string): number => {
  const len = text.length;
  if (len <= 0) return 0;

  const duration = 1100 - len * 1.2;
  return clamp(duration, 350, 1100);
};

export const getTypewriterChunkSize = (text: string, frameMs = 16): number => {
  const len = text.length;
  if (len <= 0) return 1;
  const duration = getTypewriterTotalDurationMs(text);
  const frames = Math.max(1, Math.floor(duration / frameMs));
  return Math.max(1, Math.ceil(len / frames));
};

export const useTypewriterText = (
  text: string | undefined,
  enabled: boolean,
): { text: string; done: boolean } => {
  const full = text ?? "";
  const frameMs = 16;
  const chunk = useMemo(() => getTypewriterChunkSize(full, frameMs), [full]);

  const [idx, setIdx] = useState<number>(() => (enabled ? 0 : full.length));

  useEffect(() => {
    setIdx(enabled ? 0 : full.length);
  }, [full, enabled]);

  useEffect(() => {
    if (!enabled) return;
    if (!full) return;
    if (idx >= full.length) return;

    const timer = window.setInterval(() => {
      setIdx((prev) => Math.min(full.length, prev + chunk));
    }, frameMs);

    return () => {
      window.clearInterval(timer);
    };
  }, [chunk, enabled, frameMs, full, idx]);

  return {
    text: full.slice(0, idx),
    done: !enabled || idx >= full.length,
  };
};


